module.exports = __webpack_public_path__ + "img/Enzymotherapy20.5eaba7da.jpg";